import React from 'react'
import { Switch, Redirect, Route } from 'react-router-dom'
import { Helmet } from 'react-helmet-async'

import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { userActions, specialPromotionActions } from './redux/actions'
import { combinePromotionsById } from './utilities/specialPromotion.util'

import PublicOnlyRoute from './components/PublicOnlyRoute/PublicOnlyRoute'
import ClaimReward from './containers/ClaimReward/ClaimReward'
import HeaderV2 from './components/Header/HeaderV2'
import FooterV2 from './components/Footer/FooterV2'
import PrivateRoute from './components/PrivateRoute/PrivateRoute'
import MyAccount from './containers/MyAccount/MyAccount'
import MyRewards from './containers/MyRewards/MyRewards'
import SupportV2 from './containers/SupportV2/SupportV2'
import Login from './containers/Login/Login'
import Register from './containers/Register/Register'
import ForgotPassword from './containers/ForgotPassword/ForgotPassword'
import ResetPassword from './containers/ResetPassword/ResetPassword'
import ActivateAccount from './containers/ActivateAccount/ActivateAccount'
import VerifyEmail from './containers/VerifyEmail/VerifyEmail'
import VerifyPhone from './containers/VerifyPhone/VerifyPhone'
import ProofOfPurchase from './containers/ProofOfPurchase/ProofOfPurchase'
import DownloadPVT from './containers/DownloadPVT/DownloadPVT'
import FaqItemDirectLink from './containers/Faq/FaqElasticSearch/FaqItemDirectLink'
import FaqES from './containers/Faq/FaqES'
import Terms from './containers/Terms/Terms'
import ScreenReaderCTA from './components/ScreenReader/ScreenReaderCTA'
import Loader from './components/Loader/Loader'
import SpecialPromotionV2 from './containers/SpecialPromotionV2/SpecialPromotionV2'
import UplayRedirect from './containers/UplayRedirect/UplayRedirect'
import EpicRedirect from './containers/EpicRedirect/EpicRedirect'
import SteamRedirect from './containers/SteamRedirect/SteamRedirect'
import NotFound from './containers/NotFound/NotFound'

import './App.scss'

const promotionsMasterList = [
  {
    id: 'blackdesert',
    element: SpecialPromotionV2,
  },
  {
    id: 'genshinimpact',
    element: SpecialPromotionV2,
  },
  {
    id: 'neverwinter',
    element: SpecialPromotionV2,
  },
  {
    id: 'startrekonline',
    element: SpecialPromotionV2,
  },
  {
    id: 'worldoftanks',
    element: SpecialPromotionV2,
  },
  {
    id: 'worldofwarships',
    element: SpecialPromotionV2,
  },
]

class App extends React.Component {
  async componentDidMount() {
    const { getSessionUser, getAllPromotions, location } = this.props
    const { pathname } = location
    await getSessionUser()
    const isEspecialPromotionRute = promotionsMasterList
      .map(promotion => `/${promotion.id}`)
      .includes(pathname)
    if (isEspecialPromotionRute) {
      await getAllPromotions()
    }
  }

  renderSpecialPromotionRoutes = () => {
    const { routes, isFetchingAllPromotions } = this.props
    const pages = routes && combinePromotionsById(routes, promotionsMasterList)

    if (isFetchingAllPromotions) {
      return <Loader />
    }
    return (
      pages &&
      pages.map(promotion => (
        <Route
          key={promotion.id}
          path={`${promotion.url}`}
          render={() => <SpecialPromotionV2 promotion={promotion} />}
        />
      ))
    )
  }

  render() {
    return (
      <div className="everything">
        <Helmet titleTemplate="%s - AMD Rewards" defaultTitle="AMD Rewards" />
        <div className="everythingButFooter">
          <ScreenReaderCTA />
          <HeaderV2 {...this.props} />
          <Switch>
            <PublicOnlyRoute exact path="/" component={Login} />
            <PublicOnlyRoute exact path="/login" component={Login} />
            <PublicOnlyRoute exact path="/register" component={Register} />
            <PublicOnlyRoute exact path="/forgot-password" component={ForgotPassword} />
            <PublicOnlyRoute exact path="/reset-password" component={ResetPassword} />
            <Route exact path="/verify-email" component={VerifyEmail} />
            <Route exact path="/verify-phone" component={VerifyPhone} />
            <Redirect from="/amdrewards" to="/" />
            <Route exact path="/uplay-redirect" component={UplayRedirect} />
            <Route exact path="/epic-redirect" component={EpicRedirect} />
            <PublicOnlyRoute exact path="/oauth/steam" oauth component={SteamRedirect} />
            <Redirect exact from="/comingsoon" to="/" />
            <PrivateRoute exact path="/activate-account" component={ActivateAccount} />
            <PrivateRoute exact path="/my-account" component={MyAccount} />
            <PrivateRoute exact path="/my-rewards" component={MyRewards} />
            <Route exact path="/support" component={SupportV2} />
            <Route exact path="/pop" component={ProofOfPurchase} />
            <PrivateRoute exact path="/pvt" component={DownloadPVT} />
            <Route exact path="/terms" component={Terms} />
            <Route exact path="/faq" component={FaqES} />
            <Redirect exact from="/amd50" to="/" />
            <Route exact path="/faq/:faqCategory/:faqId" component={FaqItemDirectLink} />
            <PrivateRoute exact path="/claim-reward" component={ClaimReward} />
            <Redirect from="/privacy" to="https://www.amd.com/en/corporate/privacy" />
            {this.renderSpecialPromotionRoutes()}
            <Route path="*" component={NotFound} />
          </Switch>
        </div>
        <FooterV2 className="footer" />
      </div>
    )
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ ...userActions, ...specialPromotionActions }, dispatch)
}

const mapStateToProps = state => ({
  routes: state.specialPromotionReducer.promotionRoutes,
  isFetchingAllPromotions: state.specialPromotionReducer.isFetchingAllPromotions,
})

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(App))
